import { LS, Distance } from '../../utils-and-data/utils.js';
import { DefaultPosition, IntervalTimes } from '../../utils-and-data/data.js';

export default class GeoLocation {
	constructor({
		moo=true
	} = {}) {
	
		this.oldPosition = LS.get('currentPosition');
		if (this.oldPosition) {
			this.oldPosition = JSON.parse(this.oldPosition);
		} else {
			this.oldPosition = DefaultPosition;
		}
		this.currentPosition = this.oldPosition;
		this.diffThreshold = 2;
		// Conversion base : 1 day = 86400000ms
		this.expiryTime = 86400000;
	}
	
	stopChecking() {
		clearInterval(this.intervalTimer);
	}

	checkDiff(newCoords) {
		let a = {
			lat: newCoords.latitude, 
			lng: newCoords.longitude
		}, b = {
			lat: this.oldPosition.latitude, 
			lng: this.oldPosition.longitude
		};
		let dist = Distance.compare(a,b);
		// console.log('checkDiff:', dist);
		this.oldPosition = newCoords;
		return Math.abs(dist.dist);
	}

	// @TODO: This functionality should be offloaded into a web-worker:
	beginAutoCheck({
		interval=IntervalTimes.get('geo'),
		handleDistanceChange=null
	} = {}) {
		
		this.intervalTimer = setInterval(() => {
			this.get().then(position => {
				let checkDiff = this.checkDiff(position);
				if (checkDiff >= this.diffThreshold
					&& handleDistanceChange !== null) {

					handleDistanceChange(this.currentPosition);
				}
			});
		}, interval);
	}

	get({} = {}) {
		return new Promise((res,rej) => {
			if (!navigator.geolocation){
		    
		    // @TODO: handle this error somehow... ?
		    // Maybe resolve with old coords from Local storage (if we have them)
		    res(this.currentPosition);
		  }

			navigator.geolocation.getCurrentPosition(position => {
				this.currentPosition = {
					latitude: position.coords.latitude,
				  longitude: position.coords.longitude,
				  accuracy: position.coords.accuracy,
				  timestamp: Number(new Date())
				};
				
				// @TODO: if LS accuracy is higher than the current coords, or if the 
				// old coords are 'expired', set the new coords to LS.
				LS.set('currentPosition', JSON.stringify(this.currentPosition));
				res(this.currentPosition);
			}, error => {

				// On error, stop the auto-check interval
				clearInterval(this.intervalTimer);

				// Just resolve the promise, and return the default coords:
				res(this.currentPosition);
			}, {
		    enableHighAccuracy: true,
		    timeout: 5000,
		    maximumAge: 0
		  });
		});
	}	
}



// WEBPACK FOOTER //
// ./app/frontend/components/sensor-axs/geo-location.js